import React from 'react';

const handleClickAwayLanguageSelection = (
  event: MouseEvent | TouchEvent,
  setLanguageSelectionFormOpen: React.Dispatch<React.SetStateAction<boolean>>,
): void => {
  const target = event.target as HTMLElement;
  if (target.tagName !== 'BODY') {
    setLanguageSelectionFormOpen(false);
  }
};

export default handleClickAwayLanguageSelection;
